import {
    DEALERPROFILE_SUCCESS,
    DEALERPROFILE_FAILED,
    RESET_DEALERPROFILE,
    LOADING_DEALERPROFILE,
    NETWORK_ERROR_DEALERPROFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerProfile = () => {
    return { type: RESET_DEALERPROFILE };
};


const dealerProfile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERPROFILE });
    await dealerServices
        .post("profile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetProfilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetProfileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERPROFILE,
                payload: err
            });
        });
}

function dealerGetProfilesuccess(data) {
    return {
        type: DEALERPROFILE_SUCCESS,
        payload: data
    };
}

function dealerGetProfileFailed(data) {
    return {
        type: DEALERPROFILE_FAILED,
        payload: data
    };
}
export { resetDealerProfile, dealerProfile }